module.exports = __webpack_public_path__ + "img/BLANCO_Development.2f7b80ab.png";